import { render, staticRenderFns } from "./COMScreen1.vue?vue&type=template&id=06adf02d&"
import script from "./COMScreen1.vue?vue&type=script&lang=js&"
export * from "./COMScreen1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports